import React from 'react';
import { Button } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SmallRate from 'Shared/common/components/SmallRate';
import { VertImage } from '@vertem-core/vertice-ds';

const StoreItem = ({ data }) => {

  const Navigate = useNavigate();
  const Average = useSelector(({ Average: d }) => d);

  return (
    <div className="StoreItem">
      <section
        className="StoreItem-box"
      >
        <figure
          className="StoreItem-figure"
        >
          <VertImage
              alt={data.name}
              src={data.imageUrl}
              placeholder="https://vertice-ds.s3.amazonaws.com/Assets/Images/fallbacks/fallback-img-store.png"
              fallback="https://vertice-ds.s3.amazonaws.com/Assets/Images/fallbacks/fallback-img-store.png"
          />
        </figure>
        <div>
          <p className="StoreItem-name">
            { data.name }
          </p>
          {(() => {
            if (
              !Average
              || !Average[data.supplierId]
              || Average[data.supplierId].isLoading
              || Average[data.supplierId].data === null
            ) {
              return null;
            }
            return (
              <SmallRate
                rate={Average[data.supplierId].data.average || 0}
                total={Average[data.supplierId].data.totalCount || 0}
              />
            );
          })()}
          <Button
            type="link"
            size="large"
            style={{
              padding: '0',
              height: 'auto',
            }}
            onClick={() => {
              Navigate(`/store/${data.supplierId}/1`);
            }}
          >
            <span style={{ fontWeight: '500' }} className="StoresShowcase_link_span">
              Ir para produtos
              {' '}
              <ArrowRightOutlined />
            </span>
          </Button>
        </div>
      </section>
    </div>
  );
};

StoreItem.propTypes = {
  data: PropTypes.object,
};

export default StoreItem;
